// extracted by mini-css-extract-plugin
export default {"imageWrapper":"xJ-z","twoColumnImage":"yJ-z"};